import React from "react";
import { tarifs, infosImportantes } from "../mock";
import { Eye, User, Flower2, Footprints, HandHeart, Sparkles, Scissors, Palette, Gem } from "lucide-react";

const iconMap = {
  visage: User,
  corps: Flower2,
  massages: HandHeart,
  pieds: Footprints,
  medicale: Sparkles,
  regard: Eye,
  epilation: Scissors,
  maquillage: Palette,
  nouveautes: Gem
};

const PriceRow = ({ item }) => (
  <div className="py-2.5 border-b border-taupe/30 last:border-0">
    <div className="flex items-baseline justify-between gap-4">
      <div className="flex-1">
        <div className="flex items-baseline gap-2 flex-wrap">
          <span className="w-1 h-1 rounded-full bg-gold" />
          <span className="font-cormorant text-brown text-[17px]">{item.name}</span>
          {item.duration && (
            <span className="font-cormorant italic text-brown/60 text-sm">({item.duration})</span>
          )}
        </div>
        {item.detail && (
          <p className="font-cormorant italic text-brown/60 text-[13px] mt-0.5 ml-3 whitespace-pre-line">
            {item.detail}
          </p>
        )}
      </div>
      <span className="font-serif text-gold-dark text-[15px] whitespace-nowrap">{item.price}</span>
    </div>
  </div>
);

const Category = ({ id, data }) => {
  const Icon = iconMap[id] || Sparkles;
  return (
    <div className="bg-cream border border-taupe/40 p-6 md:p-8">
      <div className="flex items-center gap-3 mb-5">
        <Icon size={22} className="text-gold-dark" strokeWidth={1.3} />
        <h3 className="font-serif tracking-[0.25em] text-brown text-[13px] uppercase">
          {data.title}
        </h3>
      </div>
      {data.subtitle && (
        <p className="font-cormorant italic text-brown/70 text-sm mb-3">{data.subtitle}</p>
      )}
      <div>
        {data.items.map((it, i) => <PriceRow key={i} item={it} />)}
      </div>
      {data.subSections && data.subSections.map((sub, i) => (
        <div key={i} className="mt-5">
          <p className="font-serif text-[11px] tracking-[0.25em] text-gold-dark uppercase mb-2">{sub.title}</p>
          {sub.items.map((it, j) => <PriceRow key={j} item={it} />)}
        </div>
      ))}
    </div>
  );
};

const Tarifs = () => {
  return (
    <section id="tarifs" className="py-24 md:py-32 bg-sand">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <p className="font-serif text-[11px] tracking-[0.35em] text-gold-dark mb-6">GRILLE TARIFAIRE</p>
          <h2 className="font-serif text-4xl md:text-6xl text-brown">
            Nos <span className="font-vibes text-gold-dark text-5xl md:text-7xl">tarifs</span>
          </h2>
          <div className="gold-divider my-6">
            <span className="w-1.5 h-1.5 rounded-full bg-gold" />
          </div>
          <p className="font-cormorant italic text-brown/75 text-lg">
            Des prestations pensées pour vous révéler.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Category id="visage" data={tarifs.visage} />
          <Category id="corps" data={tarifs.corps} />
          <Category id="massages" data={tarifs.massages} />
          <Category id="pieds" data={tarifs.pieds} />
          <Category id="medicale" data={tarifs.medicale} />
          <Category id="regard" data={tarifs.regard} />
          <Category id="epilation" data={tarifs.epilation} />
          <Category id="maquillage" data={tarifs.maquillage} />
          <Category id="nouveautes" data={tarifs.nouveautes} />
        </div>

        {/* Infos importantes */}
        <div className="mt-14 bg-cream border border-taupe/40 p-8 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-gold" />
            <h3 className="font-serif tracking-[0.3em] text-brown text-xs uppercase">
              Informations importantes
            </h3>
            <span className="w-8 h-px bg-gold" />
          </div>
          <ul className="grid md:grid-cols-2 gap-3">
            {infosImportantes.map((info, i) => (
              <li key={i} className="flex items-start gap-3 font-cormorant text-brown/85 text-[15px]">
                <span className="w-1.5 h-1.5 rounded-full bg-gold mt-2.5 flex-shrink-0" />
                <span>{info}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Tarifs;
